import sdl from '@jds/react-generated-sdl/JDSDatepickerCalendar';
import type { JDSDatepickerCalendarProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDatepickerCalendarProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSDatepickerCalendar',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DatepickerCalendar = withLogic(
  Component
) as React.FC<JDSDatepickerCalendarProps> & { slotName?: string };

DatepickerCalendar.displayName = 'DatepickerCalendar';
DatepickerCalendar.slotName = 'jds_datepicker_calendar';

export { DatepickerCalendar, type JDSDatepickerCalendarProps };
